import { ChangeDetectionStrategy, Component, DestroyRef, Inject, inject, OnInit } from "@angular/core";
import { isNil } from "lodash";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { SettingsService } from "../../../shared/services/settings.service";
import { SelectedCandidateForEdit } from "../candidate-edit/candidate-edit.model";
import { CandidateFlexibleEditService } from "./candidate-flexible-edit.service";
import { NewUiCandidateEditComponent } from "../candidate-edit/new-ui-candidate-edit.component";

@Component({
  selector: "new-ui-candidate-flexible-edit",
  templateUrl: "./new-ui-candidate-flexible-edit.component.html",
  imports: [NewUiCandidateEditComponent],
  host: { class: "h-full" },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewUiCandidateFlexibleEditComponent implements OnInit {
  private readonly flexibleEditService = inject(CandidateFlexibleEditService);
  private readonly destroyRef = inject(DestroyRef);

  private hasSavedCandidate = false;

  candidateId: string;
  candidateOrganizationId: string;

  selectedCandidate: SelectedCandidateForEdit;

  constructor(
    private readonly settings: SettingsService,
    @Inject(DynamicDialogConfig)
    private readonly config: DynamicDialogConfig,
    @Inject(DynamicDialogRef)
    private readonly dialog: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    this.selectedCandidate = this.getSelectedCandidate(
      this.config.data.candidateId,
      this.config.data.candidateOrganizationId
    );

    // On destroy rather than in close(): the dialog can also be closed by its own close icon, which bypasses close().
    this.destroyRef.onDestroy(() => {
      if (!this.hasSavedCandidate || isNil(this.selectedCandidate)) {
        return;
      }

      this.flexibleEditService.notifyCandidateSavedAndClosed(
        this.selectedCandidate.id,
        this.selectedCandidate.organizationId
      );
    });
  }

  protected onCandidateUpdated(): void {
    this.hasSavedCandidate = true;
  }

  protected close(): void {
    this.dialog.close();
  }

  private getSelectedCandidate(candidateId: string, candidateOrganizationId: string): SelectedCandidateForEdit {
    if (isNil(candidateId) || isNil(candidateOrganizationId)) return null;

    return {
      id: candidateId,
      organizationId: candidateOrganizationId,
      immigrationCountry: this.settings.standardImmigrationCountry,
    };
  }
}
